export enum ExtensionSlot {
    TopControlBar = 'top-control-bar',
    BottomControlBar = 'bottom-control-bar',
    Menu = 'menu'
}
